import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { DepartmentFragmentDoc } from '../../fragments/generated/Department';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DepartmentsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.DepartmentsFilters>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
}>;


export type DepartmentsQuery = { departments: { totalCount: number, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, name: string } }> | null } };


export const DepartmentsDocument = /*#__PURE__*/ gql`
    query departments($filters: DepartmentsFilters, $first: Float, $after: String, $sort: [SortType!]) {
  departments(filters: $filters, first: $first, after: $after, sort: $sort) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...Department
      }
    }
  }
}
    ${DepartmentFragmentDoc}`;

export function useDepartmentsQuery(options?: Omit<Urql.UseQueryArgs<DepartmentsQueryVariables>, 'query'>) {
  return Urql.useQuery<DepartmentsQuery, DepartmentsQueryVariables>({ query: DepartmentsDocument, ...options });
};